/* eslint-disable import/prefer-default-export */
export const outerStyle = {
  width: `400px`,
  maxWidth: `100%`,
};

export const iconSize = `18px`;
